import * as React from 'react';
import styled from 'styled-components';

import { verticalSpace } from '@doltech/utils/lib/css-style';
import { environment } from '@doltech/core/lib/environment/environment';
import { IconSystemV2CourseArrowArrowRightLine } from '@doltech/icons/SystemV2/IconSystemV2CourseArrowArrowRightLine';
import { IconSystemV2CourseSchoolGraduateHatStudy } from '@doltech/icons/SystemV2/IconSystemV2CourseSchoolGraduateHatStudy';
import { IconSystemV2SpecificBulb2LightIdea } from '@doltech/icons/SystemV2/IconSystemV2SpecificBulb2LightIdea';
import { IconSystemV2SpecificStarsSparkle } from '@doltech/icons/SystemV2/IconSystemV2SpecificStarsSparkle';

import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';
import { LineDivider } from '../Divider/LineDivider';
import { TextLink } from '../TextLink/TextLink';
import { Link } from '../Link';
import { PromoCard } from '../PromoCard/PromoCard';

const BottomAction = styled.div`
  display: flex;
`;

const CardList = styled.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  gap: 24px;
`;

const Container = styled.div`
  ${verticalSpace(20)}
`;

export const BlogPromotion = () => {
  return (
    <Container className="blog-promotion">
      <ResponsiveTypography.Paragraph variant="semi-bold/20-28" color="gray180">
        Tìm hiểu DOL English
      </ResponsiveTypography.Paragraph>
      <CardList>
        <Link
          href={`${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/hall-of-fame`}
          target="_blank"
        >
          <PromoCard
            type="style-2"
            title="Điểm & Review"
            description="Thành tích và hàng ngàn review dài tám cây số."
            color="primary"
            icon={<IconSystemV2SpecificStarsSparkle />}
          />
        </Link>

        <Link
          href={`${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/linearteachers`}
          target="_blank"
        >
          <PromoCard
            type="style-2"
            title="Đội ngũ giáo viên"
            description="Những giáo viên giỏi kiến thức và giỏi truyền đạt."
            color="green"
            icon={<IconSystemV2CourseSchoolGraduateHatStudy />}
          />
        </Link>
        <Link
          href={`${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/gioi-thieu-linearthinking`}
          target="_blank"
        >
          <PromoCard
            type="style-2"
            title="Linearthinking"
            description="Hệ phương pháp Linear-thinking độc quyền tại DOL."
            color="blue"
            icon={<IconSystemV2SpecificBulb2LightIdea />}
          />
        </Link>
      </CardList>
      <LineDivider directional="horizontal" space={0} />
      <BottomAction>
        <Link href="https://m.me/dolenglish.ieltsdinhluc" target="_blank">
          <TextLink
            color="blue"
            size="medium"
            text="Test đầu vào IELTS miễn phí"
            iconRight={<IconSystemV2CourseArrowArrowRightLine />}
          />
        </Link>
      </BottomAction>
    </Container>
  );
};
